import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { HttpMethod } from 'src/constants/constant';
import { HttpCustomOptions } from 'src/services/http-interceptor.service';
import { ServiceManagerService } from '../service-manager.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  email:any = "";
  password: any = "";
  showPassword = false;
  constructor(public serviceManager: ServiceManagerService, public router: Router) { 
    serviceManager.navToValidRoute()
  }

  ngOnInit(): void {
  }

  loginUser(){
    var body = {
      "email": this.email.trim(),
      "password": this.password.trim(),
      "is_admin": true
    }
    const customOptions : HttpCustomOptions = {
      showErrorMessage: true,
      showSuccessMessage: false,
      createLoaderAction: true
    }
    this.serviceManager.CallBackendServiceAPI('login-user', body, HttpMethod.POST, customOptions, false).subscribe( (data: any)=>{
      if(data){
        var response = data.response
        if(response.idToken)
          localStorage.setItem("idToken", response.idToken)
        this.serviceManager.navigateToPageWithState('/authenticate', { email: this.email})
      }
    }, (error: any) =>{
      console.log(error)
    })
  }

  navToForgotPassword(){
    this.router.navigate(['/forgot-password'])
  }
}
